$('.slider.fv').slick({
  autoplay: true,//自動的に動き出すか。初期値はfalse。
  infinite: true,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 1,//スライドを画面に3枚見せる
  //slidesToScroll: 3,//1回のスクロールで3枚の写真を移動して見せる
  prevArrow: '<div class="slick-prev"></div>',//矢印部分PreviewのHTMLを変更
  nextArrow: '<div class="slick-next"></div>',//矢印部分NextのHTMLを変更
  dots: true,//下部ドットナビゲーションの表示
  responsive: [
    {
      breakpoint: 769,//モニターの横幅が769px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に2枚見せる
        //slidesToScroll: 2,//1回のスクロールで2枚の写真を移動して見せる
      }
    },
    {
      breakpoint: 426,//モニターの横幅が426px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に1枚見せる
        //slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
      }
    }
  ]
});

$('.slider.product').slick({
  autoplay: false,//自動的に動き出すか。初期値はfalse。
  infinite: false,//スライドをループさせるかどうか。初期値はtrue。
  slidesToShow: 4,//スライドを画面に4枚見せる
  //slidesToScroll: 1,//1回のスクロールで3枚の写真を移動して見せる
  arrows: true,
  dots: true,//下部ドットナビゲーションの表示
  responsive: [
    {
      breakpoint: 768,//モニターの横幅が768px以下の見せ方
      settings: {
        slidesToShow: 3,//スライドを画面に○枚見せる
        //slidesToScroll: 2,//1回のスクロールで2枚の写真を移動して見せる
      }
    },
    {
      breakpoint: 540,//モニターの横幅が540px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に1枚見せる
        //slidesToScroll: 1,//1回のスクロールで1枚の写真を移動して見せる
        centerMode: true,
        centerPadding: "15%",
      }
    }
  ]
});